import { TFunction } from "i18next";
import { useForm } from "react-hook-form";

import useLocalizedYupResolver from "../../../../hooks/localizedYupResolver";
import {
  billingAddressIdSchema,
  billingAddressSchema,
  contactSchema,
  creditCardTokenSchema,
} from "./schema";
import {
  BillingAddressForm,
  BillingAddressIdForm,
  ContactForm,
  CreditCardTokenForm,
} from "../../Training.types";

export const useContactForm = (unprefixedT: TFunction) => {
  const resolver = useLocalizedYupResolver(contactSchema(unprefixedT));
  return useForm<ContactForm>({
    resolver,
  });
};

export const useCreditCardTokenForm = () => {
  const resolver = useLocalizedYupResolver(creditCardTokenSchema());
  return useForm<CreditCardTokenForm>({
    resolver,
  });
};

export const useBillingAddressForm = (unprefixedT: TFunction) => {
  const resolver = useLocalizedYupResolver(billingAddressSchema(unprefixedT));
  return useForm<BillingAddressForm>({
    resolver,
  });
};

export const useVerifyAddressForm = () => {
  const resolver = useLocalizedYupResolver(billingAddressIdSchema);
  return useForm<BillingAddressIdForm>({
    resolver,
  });
};
